import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckAuth } from 'src/Services/utility.service';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ActionItemListViewModel, TracItActionCalendarSearch } from 'src/Models/TracItModel';
import { ActionItemService } from 'src/Services/tracit.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { TracItActionStatusPopupComponent } from 'src/app/Shared/TracIt/action-status-popup/action-status-popup.component';
import { TracItNotesPopupComponent } from 'src/app/Shared/TracIt/notes-popup/notes-popup.component';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-action-updates',
  templateUrl: './action-updates.component.html',
  styleUrls: ['./action-updates.component.css']
})
export class TracItActionUpdatesComponent implements OnInit {
  tokenKey: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  loginUser: any;

  ClientSelectedTool: string;
  productId: number = 1;

  isRecords: number = -1;
  isDataLoad: boolean = false;

  parentSearchModel = new TracItActionCalendarSearch();
  listView: ActionItemListViewModel[];
  orderBy: any = 'ModifiedDate DESC';
  isAscending: boolean = false;
  upDowDeadlineDateCSS: string = '';
  upDowUpdateDateCSS: string = '';
  upDowStateCSS: string = '';
  upDowTypeCSS: string = '';
  upDowCategoryCSS: string = '';
  upDowStatusCSS: string = '';
  upDowNotesCSS: string = '';
  totalRecordCount: number = 0;

  tracItUnreadflag: boolean = true;
  tracItUnread: number = 0;

  constructor(private readonly titleService: Title,
    private readonly modalService: NgbModal,
    private readonly checkAuth: CheckAuth,
    private readonly actionServices: ActionItemService,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');
    this.productId = ToolEnum.actionitem;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();

    this.titleService.setTitle('Updates | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.loginUser = sessionStorage.getItem('UserId');

    this.parentSearchModel.statusIds = '0';
    this.parentSearchModel.userId = this.loginUser;
    this.parentSearchModel.dateFrom = null;
    this.parentSearchModel.toDate = null;

    this.parentSearchModel.pageNumber = 1;
    this.parentSearchModel.pageSize = 10;

    let tracItReadflag = sessionStorage.getItem('tracItUnreadflag');
    this.tracItUnreadflag = tracItReadflag === 'true' ? true : false;

    let tracItUnreadcount = sessionStorage.getItem('tracItUnread');

    this.tracItUnread = parseInt(tracItUnreadcount);


    this.GetActionItemSearchListForUpdate();
    ApplicationActivityStore('View', 'Trac It - Updates', this.appActivity, ToolEnum.actionitem, ActionActivity['Trac It'], '/trac-it/Updates');
  }

  ngOnInit() {

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetActionItemSearchListForUpdate() {
    this.blockDocument();
    this.isDataLoad = true;
    this.listView = [];
    this.actionServices.GetActionItemSearchListForUpdateV2(this.tokenKey, this.orderBy, this.parentSearchModel).subscribe(
      data => {
        this.isDataLoad = false;
        this.unblockDocument();
        this.listView = data['listView'];
        this.totalRecordCount = data['listView'][0].totalRecords;
        this.isRecords = this.totalRecordCount;

        sessionStorage.setItem('tracItUnreadflag', 'true');
        this.tracItUnreadflag = true;
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  OpenActionStatusPopup(actionId: any, updateId: any, isInformationOnly: boolean, briefingId) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    if (isInformationOnly) {
      this.OpenNotesPopup(actionId, updateId, briefingId);
    }
    else {
      const modalRef = this.modalService.open(TracItActionStatusPopupComponent, { size: 'lg', windowClass: 'actionstatus-modal-window' }).result.then(
        result => {
          if (result == 'Yes') {
            this.parentSearchModel.statusIds = '1';
            this.GetActionItemSearchListForUpdate();
          }
        },
        reason => {
        });
    }
  }

  OpenNotesPopup(actionId: any, updateId: any, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(TracItNotesPopupComponent, { size: 'lg', windowClass: 'note-modal-window' }).result.then(
      result => {
        this.parentSearchModel.statusIds = '1';
        this.GetActionItemSearchListForUpdate();
      });
  }

  setClass(status) {
    if (status === 'Acknowledged') {
      return 'btn label label-primary  ack_message';
    } else if (status === 'Done') {
      return 'btn label label-success  done_message';
    } else if (status === 'Pending') {
      return 'btn label label-danger  btn_pendding';
    } else {
      return 'btn label label-default ign_message';
    }
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  sort(sortBy: string) {
    this.parentSearchModel.statusIds = '1';
    this.upDowDeadlineDateCSS = '';
    this.upDowUpdateDateCSS = '';
    this.upDowStateCSS = '';
    this.upDowTypeCSS = '';
    this.upDowCategoryCSS = '';
    this.upDowStatusCSS = '';
    this.upDowNotesCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateDateCSS = 'active';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active-up';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateDateCSS = 'active-up';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active-up';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active-up';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active-up';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active-up';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active-up';
      }
    }
    this.viewallupdates();
  }

  viewallupdates() {
    this.tracItUnread = 0;
    this.isDataLoad = true;
    this.listView = [];
    this.actionServices.GetActionItemSearchListForAllUpdatesV2(this.tokenKey, this.orderBy, this.parentSearchModel).subscribe(
      data => {
        this.isDataLoad = false;
        this.unblockDocument();
        this.listView = data['listView'];
        this.totalRecordCount = data['listView'][0].totalRecords;
        this.isRecords = this.totalRecordCount;
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  pageChanged($event: any) {
    this.parentSearchModel.pageNumber = $event.page;
    this.GetActionItemSearchListForUpdate();
  }
}
